
import { Search, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { StrategyProvider } from "@/types/strategy-types";

interface TableFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  approvalFilter: string;
  onApprovalFilterChange: (value: string) => void;
  providerFilter: string;
  onProviderFilterChange: (value: string) => void;
  onCreateClick: () => void;
  providers?: StrategyProvider[];
}

const TableFilters = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  approvalFilter,
  onApprovalFilterChange,
  providerFilter,
  onProviderFilterChange,
  onCreateClick,
  providers = []
}: TableFiltersProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-4">
      <div className="relative flex-1">
        <Input
          placeholder="Search by strategy name..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-8"
        />
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
      </div>
      <Select
        value={statusFilter}
        onValueChange={onStatusFilterChange}
      >
        <SelectTrigger className="w-full sm:w-[160px]">
          <SelectValue placeholder="Price plan" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Plans</SelectItem>
          <SelectItem value="pro">Pro</SelectItem>
          <SelectItem value="free">Free</SelectItem>
        </SelectContent>
      </Select>
      <Select
        value={approvalFilter}
        onValueChange={onApprovalFilterChange}
      >
        <SelectTrigger className="w-full sm:w-[160px]">
          <SelectValue placeholder="Approval status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Statuses</SelectItem>
          <SelectItem value="approved">Approved</SelectItem>
          <SelectItem value="pending">Pending</SelectItem>
        </SelectContent>
      </Select>
      {providers.length > 0 && (
        <Select
          value={providerFilter}
          onValueChange={onProviderFilterChange}
        >
          <SelectTrigger className="w-full sm:w-[160px]">
            <SelectValue placeholder="Provider" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Providers</SelectItem>
            {providers.map((provider) => (
              <SelectItem key={provider.id} value={provider.id}>
                {provider.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      <Button onClick={onCreateClick} className="whitespace-nowrap">
        <Plus className="w-4 h-4 mr-2" />
        New Strategy
      </Button>
    </div>
  );
};

export default TableFilters;
